import React from "react";
import styled from "styled-components";
import { func } from "../../../../utils";
import { useFetchActivityDetail } from "../../../../networks";
import { Loading } from "../../../../components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  gap: 24px;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 24px;
`;

const Title = styled.h2`
  color: #1f2d3d;
  font-family: Gilroy;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.32;
  letter-spacing: 0.36%;
`;

const Description = styled.p`
  color: #6a7481;
  font-family: Gilroy;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.5%;
`;

const Button = styled.button`
  display: flex;
  width: 100%;
  max-width: 327px;
  height: 44px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;

  margin-top: 16px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 40px;
  background-color: #00bcf1;
  cursor: pointer;
`;

const ActivityPopupContent = ({ data, currentCity }) => {
  const { data: dataActivityDetailRaw, isLoading: isLoadingActivityDetail } =
    useFetchActivityDetail(
      { region: currentCity, slug: data?.slug },
      !!data?.slug
    );
  const dataActivityDetail = dataActivityDetailRaw?.data?.data;
  const handleButtonClick = () => {
    // Handle the button click - open registration form or external URL
    if (dataActivityDetail?.button_url) {
      window.open(dataActivityDetail?.button_url, "_blank");
    } else {
      console.log("No URL provided for the button.");
    }
  };

  return (
    <Container>
      {isLoadingActivityDetail && <Loading />}
      <Content>
        <Title>{data?.title || "Activity"}</Title>
        <Description
          dangerouslySetInnerHTML={{
            __html: dataActivityDetail?.content ?? "-",
          }}
        />
      </Content>
      {dataActivityDetail?.has_button ? (
        <Button onClick={handleButtonClick}>
          {dataActivityDetail?.button_text}
        </Button>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default ActivityPopupContent;
